import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export default function NotFound() {
  return (
    <>
      <SEO
        title="404 - Siden blev ikke fundet"
        description="Siden du leder efter findes ikke på Hoofcare."
      />

      <section className="py-24 bg-sand-50 min-h-[60vh] flex items-center justify-center">
        <div className="max-w-md mx-auto px-4 text-center space-y-6">
          <div className="w-20 h-20 bg-forest-100 text-forest-800 rounded-2xl flex items-center justify-center mx-auto text-4xl shadow-xs">
            <i className="fa-solid fa-compass"></i>
          </div>

          <div className="space-y-2">
            <span className="text-xs font-bold uppercase tracking-wider text-earth-700">Fejl 404</span>
            <h1 className="text-3xl font-bold text-forest-900 tracking-tight">Siden blev ikke fundet</h1>
            <p className="text-sm text-charcoal-600 leading-relaxed">
              Siden du søgte efter findes desværre ikke eller er blevet flyttet.
            </p>
          </div>

          <div className="pt-2">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-forest-900 hover:bg-forest-800 text-white font-bold text-sm transition-colors cursor-pointer shadow-xs"
            >
              <i className="fa-solid fa-house text-emerald-400"></i>
              <span>Gå til forsiden</span>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
